import * as React from "react";
import {MouseEventHandler} from "react";

import SVG from "react-inlinesvg";

export type GeoICONS =
    "3d_glasses" |
    "about" |
    "add" |
    "address_book2" |
    "adhesive_tape" |
    "air_tube_carrier" |
    "airbrush" |
    "airplane" |
    "airplane2" |
    "airplane2_landing" |
    "airplane2_starting" |
    "airship" |
    "alarm" |
    "alarmclock" |
    "ambulance" |
    "ammunition_box_closed" |
    "ammunition_box_open" |
    "anchor" |
    "angel" |
    "antenna" |
    "apple" |
    "apple_bite" |
    "armour" |
    "army_knife" |
    "arrow_around" |
    "arrow_barrier" |
    "arrow_circle" |
    "arrow_circle2" |
    "arrow_cross" |
    "arrow_curve_left" |
    "arrow_down" |
    "arrow_down_left" |
    "arrow_down_right" |
    "arrow_fork" |
    "arrow_fork2" |
    "arrow_from" |
    "arrow_into" |
    "arrow_join" |
    "arrow_join2" |
    "arrow_junction" |
    "arrow_left" |
    "arrow_loop" |
    "arrow_loop2" |
    "arrow_loop3" |
    "arrow_merge" |
    "arrow_merge2" |
    "arrow_mix" |
    "arrow_out" |
    "arrow_over" |
    "arrow_right" |
    "arrow_shuffle" |
    "arrow_spread" |
    "arrow_spread2" |
    "arrow_squiggly" |
    "arrow_through" |
    "arrow_to" |
    "arrow_turn_left" |
    "arrow_u_turn" |
    "arrow_up" |
    "arrow_up_left" |
    "arrow_up_right" |
    "ashtray_cigarette" |
    "astrologer" |
    "astronaut" |
    "athlete" |
    "atm" |
    "atom" |
    "atom2" |
    "auction_hammer" |
    "audio_cassette" |
    "axe" |
    "baby" |
    "back" |
    "backpack" |
    "bacon" |
    "bacteria" |
    "badminton_racket" |
    "bag" |
    "bags" |
    "balloon" |
    "balloons" |
    "ballpen" |
    "banana" |
    "band_aid" |
    "bank_building" |
    "barcode" |
    "barcode_scanner" |
    "barrel" |
    "barrels" |
    "barrier_closed" |
    "barrier_open" |
    "baseball" |
    "baseball_bat" |
    "basketball" |
    "basketball_hoop" |
    "battery_charge" |
    "battery_plus_minus" |
    "battery_status0" |
    "battery_status1" |
    "battery_status2" |
    "battery_status3" |
    "battery_status4" |
    "battery_status5" |
    "beaker" |
    "beaker2" |
    "bear" |
    "bed" |
    "bed_empty" |
    "beer_bottle" |
    "beer_garden_table" |
    "beer_glass" |
    "beer_mug" |
    "bell" |
    "bell2" |
    "beverage_can" |
    "beverage_can_empty" |
    "bible" |
    "bicycle" |
    "bicyclist" |
    "billboard_empty" |
    "binocular" |
    "bird" |
    "blackboard" |
    "blender" |
    "blood_bag" |
    "blot" |
    "body_scale" |
    "bolt" |
    "bomb" |
    "bomb2" |
    "bone" |
    "book" |
    "book2" |
    "book_bookmark" |
    "book_headphones" |
    "book_open" |
    "book_telephone" |
    "bookkeeper" |
    "bookmark" |
    "bookmarks" |
    "books" |
    "boombox" |
    "bottle" |
    "bottle_bubbles" |
    "bottle_crate" |
    "bottle_of_pills" |
    "bow_tie" |
    "bowl" |
    "bowling_ball" |
    "bowling_pin" |
    "bowling_pins" |
    "box_closed" |
    "box_into" |
    "box_open" |
    "box_out" |
    "box_software" |
    "box_surprise" |
    "box_tall" |
    "boxing_glove" |
    "boy" |
    "brain" |
    "breakfast_egg" |
    "breakpoint" |
    "breakpoint_selection" |
    "breakpoints" |
    "breakpoints_selection" |
    "brick_trowel" |
    "brickwall" |
    "bridge" |
    "briefcase" |
    "briefcase2" |
    "briefcase2_document" |
    "briefcase_document" |
    "brush" |
    "bucket" |
    "bug" |
    "bug2" |
    "building_block" |
    "bull" |
    "bulldozer" |
    "bullet_train" |
    "bullets" |
    "buoy" |
    "bus" |
    "bus2" |
    "businessmen" |
    "businesspeople" |
    "businesspeople2" |
    "businessperson" |
    "businessperson2" |
    "businesswoman" |
    "businesswomen" |
    "button" |
    "c_clamp" |
    "cabinet" |
    "cabinet2" |
    "cabinet_flash" |
    "cabinet_open" |
    "cabinet_warning" |
    "cactus" |
    "caesar" |
    "cake" |
    "cake2" |
    "cake_slice" |
    "calculator" |
    "calendar" |
    "calendar_1" |
    "calendar_3" |
    "calendar_31" |
    "calendar_5" |
    "calendar_52" |
    "calendar_7" |
    "calendar_clock" |
    "calibration_mark" |
    "caliper" |
    "camera" |
    "can_closed" |
    "can_open" |
    "candle" |
    "candle_holder" |
    "cannon" |
    "car_compact" |
    "car_compact2" |
    "car_convertible2" |
    "car_sedan" |
    "car_sedan2" |
    "car_sports" |
    "carabiner" |
    "card_terminal" |
    "card_terminal2" |
    "cargo_container" |
    "cash_flow" |
    "cash_register" |
    "cashier" |
    "cask" |
    "castle" |
    "cd" |
    "cd_burn" |
    "cd_case" |
    "cd_drive" |
    "cd_music" |
    "cd_pirated" |
    "cd_window" |
    "central_bank" |
    "central_bank_dollar" |
    "central_bank_euro" |
    "central_bank_pound" |
    "central_bank_yen" |
    "central_bank_yuan" |
    "chainsaw" |
    "chalk" |
    "champagne_bottle" |
    "champagne_glass" |
    "chart_area" |
    "chart_bar" |
    "chart_bubble" |
    "chart_candlestick" |
    "chart_column" |
    "chart_column_stacked" |
    "chart_donut" |
    "chart_dot" |
    "chart_funnel" |
    "chart_gantt" |
    "chart_hi_lo" |
    "chart_line" |
    "chart_pie" |
    "chart_pyramid" |
    "chart_radar" |
    "chart_renko" |
    "chart_spline" |
    "chart_step" |
    "check" |
    "checkbook" |
    "checkbox" |
    "checkbox_selected" |
    "checkbox_unchecked" |
    "checkbox_unselected" |
    "checks" |
    "chess_piece_bishop" |
    "chess_piece_king" |
    "chess_piece_knight" |
    "chess_piece_pawn" |
    "chess_piece_queen" |
    "chess_piece_rook" |
    "chest" |
    "chest_into" |
    "chest_open" |
    "chest_open_full" |
    "chest_out" |
    "chocolate" |
    "christian_cross" |
    "christmas_ball" |
    "church" |
    "cigarette" |
    "cigarette_packet" |
    "cigarette_packet_empty" |
    "circus" |
    "clapperboard" |
    "clapperboard_closed" |
    "cleaver" |
    "clef" |
    "client_network" |
    "clients" |
    "clipboard" |
    "clipboard_check_edit" |
    "clipboard_checks" |
    "clipboard_empty" |
    "clipboard_paste" |
    "clipboard_paste_no_format" |
    "clock" |
    "clock_back" |
    "clock_forward" |
    "close" |
    "clothes_pin" |
    "cloud" |
    "cloud_dark" |
    "cloud_download" |
    "cloud_flash" |
    "cloud_hail" |
    "cloud_moon" |
    "cloud_network" |
    "cloud_rain" |
    "cloud_refresh" |
    "cloud_snow" |
    "cloud_sun" |
    "cloud_updown" |
    "cloud_upload" |
    "clown" |
    "coathanger" |
    "cocktail" |
    "cocktail2" |
    "code" |
    "code_beanshell" |
    "code_c" |
    "code_cplusplus" |
    "code_csharp" |
    "code_java" |
    "code_javascript" |
    "code_line" |
    "code_php" |
    "code_ruby" |
    "code_vbasic" |
    "codes_of_law" |
    "coffee_bean" |
    "coffee_beans" |
    "coffee_machine" |
    "coffin" |
    "comb" |
    "compact_camera" |
    "compass" |
    "compasses" |
    "compress" |
    "compress2" |
    "console" |
    "console_network" |
    "construction_barrier" |
    "containership" |
    "contract" |
    "contrast" |
    "contrast_low" |
    "control_panel" |
    "control_panel2" |
    "control_tower" |
    "cook" |
    "cookies" |
    "cooling_tower" |
    "cooling_tower_smoke" |
    "copy" |
    "corkscrew" |
    "correction_fluid" |
    "courthouse" |
    "cow" |
    "cpu" |
    "cpu2" |
    "cpu_flash" |
    "crack" |
    "crash_test_dummy" |
    "credit_card" |
    "credit_card2" |
    "credit_cards" |
    "criminal" |
    "crossbow" |
    "crown" |
    "cruise_ship" |
    "crutch" |
    "crystal_ball" |
    "cube_molecule" |
    "cube_molecule2" |
    "cubes" |
    "cup" |
    "currency_dollar" |
    "currency_euro" |
    "currency_plain" |
    "currency_won" |
    "currency_yen" |
    "currency_yuan" |
    "cut" |
    "dagger" |
    "dart" |
    "data" |
    "data_cloud" |
    "data_copy" |
    "data_floppy_disk" |
    "data_network" |
    "data_scroll" |
    "data_shared" |
    "data_table" |
    "debug" |
    "deck_chair" |
    "delete" |
    "delivery_man" |
    "delivery_note" |
    "delivery_truck" |
    "denture" |
    "desk" |
    "desk_lamp" |
    "desktop" |
    "detergent" |
    "devil" |
    "diamond" |
    "diamond_ring" |
    "dice" |
    "dictation_microphone" |
    "dictionary" |
    "die" |
    "disability" |
    "disinfection" |
    "diving_mask" |
    "dna" |
    "doctor" |
    "document_attachment" |
    "document_center" |
    "document_center_horizontal" |
    "document_center_vertical" |
    "document_chart" |
    "document_cup" |
    "document_empty" |
    "document_empty_landscape" |
    "document_footer" |
    "document_gear" |
    "document_header" |
    "document_heart" |
    "document_height" |
    "document_information" |
    "document_music" |
    "document_notebook" |
    "document_orientation_landscape" |
    "document_orientation_portrait" |
    "document_page_number" |
    "document_pinned" |
    "document_pulse" |
    "document_selection" |
    "document_size" |
    "document_stop" |
    "document_tag" |
    "document_text" |
    "document_width" |
    "document_zip" |
    "document_zoom_in" |
    "document_zoom_out" |
    "documents_empty" |
    "documents_exchange" |
    "dog" |
    "dome_camera" |
    "door_closed" |
    "door_exit" |
    "door_open" |
    "dot_matrix" |
    "download" |
    "dram" |
    "drink" |
    "drop" |
    "drop_down_list" |
    "drum" |
    "dude1" |
    "dude2" |
    "dude3" |
    "dude4" |
    "dude5" |
    "dude6" |
    "dug_well" |
    "dumbbell" |
    "dump_truck" |
    "dynamite" |
    "ear" |
    "earth" |
    "earth2" |
    "earth_link" |
    "earth_location" |
    "earth_music" |
    "earth_network" |
    "easel" |
    "easel_empty" |
    "edit" |
    "eightball" |
    "electric_iron" |
    "element" |
    "element_branch2" |
    "element_copy" |
    "element_selection" |
    "elements" |
    "elements2" |
    "elements3" |
    "elements4" |
    "elements_branch" |
    "elements_cascade" |
    "elements_hierarchy" |
    "elements_selection" |
    "elements_tree" |
    "emergency_stop_button" |
    "emoticon_angry" |
    "emoticon_blink" |
    "emoticon_clown" |
    "emoticon_confused" |
    "emoticon_cool" |
    "emoticon_cry" |
    "emoticon_frown" |
    "emoticon_grin" |
    "emoticon_kiss" |
    "emoticon_smile" |
    "emoticon_straight_face" |
    "emoticon_surprised" |
    "emoticon_tongue" |
    "engineer" |
    "envelope2" |
    "environment" |
    "environment_network" |
    "equalizer" |
    "erase" |
    "error" |
    "escalator" |
    "escalator_down" |
    "escalator_up" |
    "excavator" |
    "explosion" |
    "eye" |
    "eye_blind" |
    "eye_scan" |
    "eyeglasses" |
    "face_scan" |
    "factory" |
    "fan" |
    "fancy_cake" |
    "fax_machine" |
    "feeding_bottle" |
    "fence" |
    "film" |
    "film_cartridge" |
    "filter_and_sort" |
    "find_again" |
    "find_replace" |
    "find_text" |
    "fingerprint" |
    "fingerprint_scan" |
    "fire" |
    "fire_extinguisher" |
    "fire_hydrant" |
    "fire_truck" |
    "firefighter" |
    "firewall" |
    "firewall2" |
    "first_aid" |
    "first_aid_box" |
    "fish_bowl" |
    "fit_to_height" |
    "fit_to_size" |
    "fit_to_width" |
    "flame" |
    "flash" |
    "flashlight" |
    "flatscreen_tv" |
    "floppy_disk" |
    "floppy_disk_window" |
    "floppy_disks" |
    "floppy_drive" |
    "flower" |
    "folder" |
    "folder2" |
    "folder3" |
    "folder3_document" |
    "folder3_mail" |
    "folder3_movie" |
    "folder3_music" |
    "folder_cubes" |
    "folder_document" |
    "folder_document2" |
    "folder_into" |
    "folder_movie" |
    "folder_music" |
    "folder_network" |
    "folder_open" |
    "folder_out" |
    "folder_shared" |
    "folder_window" |
    "folder_zip" |
    "folders" |
    "folders2" |
    "folding_rule" |
    "font" |
    "font_style_bold" |
    "font_style_italics" |
    "font_style_normal" |
    "font_style_strikethrough" |
    "font_style_subscript" |
    "font_style_superscript" |
    "font_style_underline" |
    "football" |
    "forklift" |
    "form" |
    "formula" |
    "fortress_tower" |
    "fountain_pen" |
    "fried_egg" |
    "fried_egg_bacon" |
    "front" |
    "fuel_dispenser" |
    "funnel" |
    "gallows" |
    "gambling_chip" |
    "gambling_chips" |
    "gambling_chips2" |
    "gamepad" |
    "garbage" |
    "garbage2" |
    "garbage_can" |
    "garbage_container" |
    "garbage_full" |
    "garbage_half_full" |
    "garbage_make_empty" |
    "garbage_overflow" |
    "gas_cylinder" |
    "gauge" |
    "gauntlet" |
    "gauze_bandage" |
    "gearwheel" |
    "gearwheels" |
    "geiger_counter" |
    "genius" |
    "ghost" |
    "gift" |
    "girl" |
    "glass_cracked" |
    "glass_fork" |
    "globe" |
    "goal" |
    "goal_ball" |
    "goblet" |
    "gold_bar" |
    "gold_bars" |
    "goldfish" |
    "golf_ball" |
    "golf_club_iron" |
    "golf_club_putter" |
    "golf_club_wood" |
    "golf_flag" |
    "gps" |
    "graduate" |
    "graduation_hat" |
    "graduation_hat2" |
    "grand_piano" |
    "graph" |
    "graph_claw" |
    "graph_connection" |
    "graph_connection_directed" |
    "graph_fork" |
    "graph_fork2" |
    "graph_from" |
    "graph_node" |
    "graph_self_loop" |
    "graph_square" |
    "graph_star" |
    "graph_to" |
    "graph_triangle" |
    "graphics_tablet" |
    "grenade" |
    "guard" |
    "guillotine" |
    "guitar" |
    "gun" |
    "hair_dryer" |
    "hamburger" |
    "hammer" |
    "hammer2" |
    "hand_card" |
    "hand_count_four" |
    "hand_count_one" |
    "hand_count_three" |
    "hand_count_zero" |
    "hand_drill" |
    "hand_fist2" |
    "hand_four" |
    "hand_gun" |
    "hand_money" |
    "hand_offer" |
    "hand_paper" |
    "hand_point_left" |
    "hand_point_left2" |
    "hand_point_right" |
    "hand_point_right2" |
    "hand_point_up" |
    "hand_point_up2" |
    "hand_pump" |
    "hand_spread" |
    "hand_stop2" |
    "hand_thumb_down" |
    "hand_thumb_up" |
    "hand_touch" |
    "hand_truck" |
    "hand_truck_bag" |
    "hand_truck_box" |
    "hand_truck_suitcase" |
    "handbag" |
    "handcuffs" |
    "handheld_device" |
    "handsaw" |
    "handshake" |
    "hard_drive" |
    "hard_drive_network" |
    "hardhat" |
    "hat" |
    "hat2" |
    "headphones" |
    "headset" |
    "headstone" |
    "heart" |
    "heart_broken" |
    "heartbeat" |
    "helicopter" |
    "helmet" |
    "help_earth" |
    "history" |
    "history2" |
    "hockey_puck" |
    "hockey_stick" |
    "hole_punch" |
    "holmes" |
    "home" |
    "home_fire" |
    "home_lock" |
    "home_water" |
    "horse" |
    "hospital" |
    "hot_air_balloon" |
    "hotel" |
    "hourglass" |
    "house_framework" |
    "houses" |
    "html_tag" |
    "html_tag2" |
    "i-beam" |
    "i-beams" |
    "ice_cream" |
    "ice_cream2" |
    "icecube" |
    "id_badge" |
    "id_card" |
    "id_cards" |
    "igloo" |
    "inbox" |
    "inbox_empty" |
    "inbox_full" |
    "inbox_into" |
    "inbox_out" |
    "indent_decrease" |
    "indent_increase" |
    "index" |
    "index2" |
    "industrial_machine" |
    "industrial_robot" |
    "information" |
    "infusion_drip" |
    "injection" |
    "inkpot" |
    "install" |
    "invoice" |
    "invoice_dollar" |
    "invoice_euro" |
    "jackhammer" |
    "jar" |
    "jar_coffee_bean" |
    "jar_cookies" |
    "jar_earth" |
    "jerrycan" |
    "joystick" |
    "judge" |
    "key" |
    "key2" |
    "key3" |
    "keyboard" |
    "keyboard_key_0" |
    "keyboard_key_1" |
    "keyboard_key_2" |
    "keyboard_key_3" |
    "keyboard_key_4" |
    "keyboard_key_5" |
    "keyboard_key_6" |
    "keyboard_key_7" |
    "keyboard_key_8" |
    "keyboard_key_9" |
    "keyboard_key_a" |
    "keyboard_key_b" |
    "keyboard_key_c" |
    "keyboard_key_clock" |
    "keyboard_key_d" |
    "keyboard_key_down" |
    "keyboard_key_e" |
    "keyboard_key_empty" |
    "keyboard_key_enter" |
    "keyboard_key_f" |
    "keyboard_key_g" |
    "keyboard_key_h" |
    "keyboard_key_i" |
    "keyboard_key_j" |
    "keyboard_key_k" |
    "keyboard_key_l" |
    "keyboard_key_left" |
    "keyboard_key_m" |
    "keyboard_key_minus" |
    "keyboard_key_n" |
    "keyboard_key_o" |
    "keyboard_key_p" |
    "keyboard_key_plus" |
    "keyboard_key_q" |
    "keyboard_key_r" |
    "keyboard_key_right" |
    "keyboard_key_s" |
    "keyboard_key_shift" |
    "keyboard_key_speaker" |
    "keyboard_key_t" |
    "keyboard_key_u" |
    "keyboard_key_up" |
    "keyboard_key_v" |
    "keyboard_key_w" |
    "keyboard_key_x" |
    "keyboard_key_y" |
    "keyboard_key_z" |
    "keyboard_wireless" |
    "keyhole" |
    "keypad" |
    "keys" |
    "kidney_dish" |
    "knife" |
    "knife_fork" |
    "knife_fork_spoon" |
    "knot" |
    "ladder" |
    "lantern" |
    "lantern_on" |
    "laptop" |
    "laser_pointer" |
    "laundry_machine" |
    "laurel_wreath" |
    "layout" |
    "layout_center" |
    "layout_east" |
    "layout_horizontal" |
    "layout_north" |
    "layout_northeast" |
    "layout_northwest" |
    "layout_south" |
    "layout_southeast" |
    "layout_southwest" |
    "layout_vertical" |
    "layout_west" |
    "leaf" |
    "lectern" |
    "lecture" |
    "led" |
    "lemon" |
    "lemonade_glass" |
    "lifebelt" |
    "lightbulb_off" |
    "lightbulb_on" |
    "lighthouse" |
    "line_break" |
    "line_spacing_paragraph" |
    "line_spacing_text" |
    "link" |
    "link_broken" |
    "lipstick" |
    "list_style_bullets" |
    "list_style_numbered" |
    "list_style_roman" |
    "location_pin" |
    "lock" |
    "lock2" |
    "lock3" |
    "lock_open" |
    "log" |
    "log_in" |
    "log_out" |
    "logic_and" |
    "logic_not" |
    "logic_or" |
    "logic_xor" |
    "logs" |
    "lollipop" |
    "loudspeaker" |
    "loudspeaker2" |
    "loudspeaker3" |
    "loudspeaker4" |
    "loudspeaker_box" |
    "loudspeaker_network" |
    "loudspeaker_off" |
    "magazine_folder" |
    "magazine_folder_empty" |
    "magic_wand" |
    "magician" |
    "magnet" |
    "magnifying_glass" |
    "mail" |
    "mail2" |
    "mail_attachment" |
    "mail_bug" |
    "mail_cloud" |
    "mail_earth" |
    "mail_exchange" |
    "mail_filter" |
    "mail_forward" |
    "mail_into" |
    "mail_open" |
    "mail_open2" |
    "mail_out" |
    "mail_reply" |
    "mail_reply_all" |
    "mail_sealed" |
    "mail_virus" |
    "mail_write" |
    "mailbox_empty" |
    "mailbox_full" |
    "mails" |
    "maneki_neko" |
    "map" |
    "map_location" |
    "map_location2" |
    "map_roads" |
    "map_route" |
    "marionette" |
    "marker" |
    "market_stand" |
    "mask" |
    "masks" |
    "matryoshka" |
    "maximize" |
    "mda" |
    "measuring_cup" |
    "medal" |
    "medal2" |
    "media_beginning" |
    "media_eject" |
    "media_end" |
    "media_fast_forward" |
    "media_pause" |
    "media_play" |
    "media_record" |
    "media_rewind" |
    "media_step_back" |
    "media_step_forward" |
    "media_stop" |
    "medical_bag" |
    "megaphone" |
    "memory" |
    "memory_stick" |
    "menora" |
    "message" |
    "messages" |
    "microphone" |
    "microphone2" |
    "microscope" |
    "microwave_oven" |
    "milk" |
    "minibus" |
    "minimize" |
    "minus" |
    "mirror_horizontally" |
    "mirror_vertically" |
    "missile" |
    "missile2" |
    "mobile_crane" |
    "mobile_phone" |
    "mobilephone2" |
    "mobilephone3" |
    "modem" |
    "modem_earth" |
    "molecule_h2o" |
    "money" |
    "money2" |
    "money_bill_cut" |
    "money_bill_fire" |
    "money_bills" |
    "money_coin" |
    "money_coins" |
    "money_coins2" |
    "money_dollar" |
    "money_euro" |
    "money_interest" |
    "money_refund" |
    "moneybag" |
    "moneybag_coins" |
    "moneybag_dollar" |
    "moneybag_euro" |
    "monitor" |
    "monitor_brush" |
    "monitor_height" |
    "monitor_size" |
    "monitor_sleep" |
    "monitor_test_card" |
    "monitor_touch" |
    "monitor_width" |
    "moon" |
    "moon_half" |
    "mosque" |
    "mosquito" |
    "motor_scooter" |
    "motorbike" |
    "motorcycle_helmet" |
    "motorcyclist" |
    "mouse" |
    "mouse2" |
    "mouse2_left_button" |
    "mouse2_right_button" |
    "mouse_left_button" |
    "mouse_pointer" |
    "mouse_right_button" |
    "mousetrap" |
    "movie" |
    "movie_camera" |
    "movies" |
    "moving_truck" |
    "mug" |
    "mug_tea" |
    "multimeter" |
    "multimeter_analog" |
    "mushroom" |
    "music" |
    "nail" |
    "nav_down" |
    "nav_down_left" |
    "nav_down_right" |
    "nav_left" |
    "nav_plain" |
    "nav_redo" |
    "nav_refresh" |
    "nav_right" |
    "nav_undo" |
    "nav_up" |
    "nav_up_left" |
    "nav_up_right" |
    "navigate_beginning" |
    "navigate_check" |
    "navigate_close" |
    "navigate_cross" |
    "navigate_down" |
    "navigate_down2" |
    "navigate_end" |
    "navigate_left" |
    "navigate_left2" |
    "navigate_minus" |
    "navigate_open" |
    "navigate_plus" |
    "navigate_right" |
    "navigate_right2" |
    "navigate_up" |
    "navigate_up2" |
    "network_node" |
    "network_node2" |
    "newspaper" |
    "newtons_cradle" |
    "nonprofit" |
    "nose" |
    "note" |
    "note_block" |
    "note_pinned" |
    "note_text" |
    "notebook" |
    "notebook2" |
    "notebook3" |
    "numeric_keypad" |
    "object_alignment_bottom" |
    "object_alignment_center" |
    "object_alignment_horizontal" |
    "object_alignment_left" |
    "object_alignment_right" |
    "object_alignment_top" |
    "object_alignment_vertical" |
    "object_ball" |
    "object_cone" |
    "object_cube" |
    "object_cylinder" |
    "objects" |
    "objects2" |
    "objects3" |
    "objects4" |
    "objects_exchange" |
    "objects_transform" |
    "objects_transform2" |
    "odometer" |
    "office_building" |
    "office_building2" |
    "office_chair" |
    "oil_platform" |
    "oil_pump" |
    "ok" |
    "orange" |
    "pacemaker" |
    "pacifier" |
    "package" |
    "packaging_paper" |
    "packaging_tape" |
    "pager" |
    "pagoda" |
    "paint_brush" |
    "paint_bucket" |
    "paint_roller" |
    "painters_palette" |
    "painters_palette2" |
    "painters_palette_brush" |
    "painters_palette_empty" |
    "painting_landscape" |
    "painting_portrait" |
    "palm_tree" |
    "pan_flute" |
    "paper_fan" |
    "paper_jet" |
    "paper_jet2" |
    "paper_lantern" |
    "paper_roll" |
    "paperclip" |
    "paperclip2" |
    "parasol" |
    "parking_meter" |
    "passport" |
    "password_field" |
    "pastor" |
    "pawn" |
    "pci_card" |
    "pci_card_network" |
    "pda" |
    "pda_write" |
    "pencil" |
    "pens" |
    "pentagram" |
    "perfume" |
    "person" |
    "pet_bottle" |
    "petri_dish" |
    "phone_conference" |
    "phone_hang_up" |
    "phone_pick_up" |
    "phone_receiver" |
    "phone_receiver2" |
    "phone_speaker" |
    "phone_speech_bubble" |
    "photo_landscape" |
    "photo_portrait" |
    "photographic_filter" |
    "photographic_filters" |
    "photos" |
    "piece" |
    "piece2" |
    "pieces" |
    "pig" |
    "piggy_bank" |
    "pill" |
    "pill2" |
    "pilot" |
    "pin" |
    "pin2" |
    "pineapple" |
    "pipette" |
    "pipette_test" |
    "pirates_ship" |
    "plane_tool" |
    "planet" |
    "plank" |
    "planks" |
    "plant" |
    "platform_truck_box" |
    "platform_truck_empty" |
    "platform_truck_suitcase" |
    "playing_card_clubs" |
    "playing_card_diamonds" |
    "playing_card_hearts" |
    "playing_card_spades" |
    "playing_cards" |
    "playing_cards_deck" |
    "pliers" |
    "plug" |
    "plug2" |
    "plug_cinch" |
    "plug_lan" |
    "plug_usb" |
    "plus" |
    "podium" |
    "podium2" |
    "poison" |
    "police_car" |
    "policeman" |
    "policeman_bobby" |
    "pontifex" |
    "pool_balls" |
    "portable_barcode_scanner" |
    "portfolio_folder" |
    "post_horn" |
    "postage_stamp" |
    "power" |
    "power_drill" |
    "precision_knife" |
    "precision_square" |
    "presentation2" |
    "presentation_chart" |
    "presentation_empty" |
    "press" |
    "pressure_sprayer" |
    "pretzel" |
    "price_sticker" |
    "print_calculator" |
    "print_layout_continous" |
    "print_layout_single" |
    "printer" |
    "printer3" |
    "printer_network" |
    "progress_bar" |
    "projector" |
    "pumpkin" |
    "pumpkin_halloween" |
    "punching_bag" |
    "purchase_order" |
    "purse" |
    "pylon" |
    "quad" |
    "question" |
    "question_and_answer" |
    "quotation_mark" |
    "quotation_mark2" |
    "quotation_marks" |
    "rack_server" |
    "rack_server_network" |
    "rack_servers" |
    "radar" |
    "radiation" |
    "radio" |
    "radio_button_group" |
    "radio_button_selected" |
    "radio_button_unselected" |
    "rain_drops" |
    "razor" |
    "reactor" |
    "receipt" |
    "receipt_book" |
    "receipt_printer" |
    "record" |
    "record_player" |
    "recycle" |
    "redo" |
    "refresh" |
    "registry" |
    "remote_control" |
    "remotecontrol2" |
    "repeat" |
    "resize" |
    "reticle" |
    "rfid_chip" |
    "rfq" |
    "road_roller" |
    "robot" |
    "rocket" |
    "rocking_horse" |
    "rotate_left" |
    "rotate_right" |
    "roulette_wheel" |
    "route_sign" |
    "router" |
    "rss" |
    "rubber_stamp" |
    "safe" |
    "safe_into" |
    "safe_open_empty" |
    "safe_open_full" |
    "safe_out" |
    "safety_glasses" |
    "safety_pin" |
    "safety_pin_open" |
    "sailboat" |
    "sales_quotation" |
    "satellite" |
    "satellite_dish" |
    "sausage" |
    "save_as" |
    "scales" |
    "scalpel" |
    "scanner" |
    "school" |
    "schoolboy" |
    "schoolbus" |
    "schoolbus2" |
    "scientist" |
    "scooter" |
    "score_board" |
    "screwdriver" |
    "scroll" |
    "scroll2" |
    "scroll_bar_horizontal" |
    "scroll_bar_vertical" |
    "sd_card" |
    "security_agent" |
    "security_badge" |
    "selection" |
    "selection_delete" |
    "selection_find" |
    "selection_recycle" |
    "selection_refresh" |
    "selection_view" |
    "senior_citizen" |
    "senior_citizen2" |
    "server" |
    "server2" |
    "server_client" |
    "server_client_exchange" |
    "server_cloud" |
    "server_document" |
    "server_earth" |
    "server_from_client" |
    "server_id_card" |
    "server_into" |
    "server_mail" |
    "server_mail_download" |
    "server_mail_upload" |
    "server_network" |
    "server_out" |
    "server_to_client" |
    "service_bell" |
    "set_square" |
    "sewing_machine" |
    "shape_circle" |
    "shape_ellipse" |
    "shape_hexagon" |
    "shape_octagon" |
    "shape_pentagon" |
    "shape_rectangle" |
    "shape_rhomb" |
    "shape_square" |
    "shape_triangle" |
    "shapes" |
    "share" |
    "shelf_empty" |
    "shelf_full" |
    "shield" |
    "ship1" |
    "ship2" |
    "ships_wheel" |
    "shopping_bag" |
    "shopping_bag_full" |
    "shopping_basket" |
    "shopping_basket_full" |
    "shopping_cart" |
    "shopping_cart2" |
    "shopping_cart_full" |
    "shower_gel" |
    "shredder" |
    "shutter" |
    "shuttlecock" |
    "sickle" |
    "sign_forbidden" |
    "sign_stop" |
    "sign_warning" |
    "sign_warning_biohazard" |
    "sign_warning_flammable" |
    "sign_warning_harmful" |
    "sign_warning_radiation" |
    "sign_warning_toxic" |
    "sign_warning_voltage" |
    "sign_yield" |
    "signal_flag" |
    "signal_flag_checkered" |
    "signal_strength_0" |
    "signal_strength_1" |
    "signal_strength_2" |
    "signal_strength_3" |
    "signal_strength_4" |
    "signal_strength_5" |
    "signaling_disc" |
    "signboard_closed" |
    "signboard_empty" |
    "signboard_for_rent" |
    "signboard_for_sale" |
    "signboard_open" |
    "signboard_sold" |
    "signpost" |
    "signpost2" |
    "signpost3" |
    "sim_card" |
    "singer" |
    "sixpack_beer" |
    "sizes" |
    "skateboard" |
    "skin_cow" |
    "skin_tiger" |
    "skull" |
    "skull2" |
    "sledge" |
    "slider" |
    "slingshot" |
    "small_truck" |
    "smartcard" |
    "smartphone" |
    "smartphone_cloud" |
    "sms" |
    "snowflake" |
    "snowman" |
    "soap_dispenser" |
    "soccer_ball" |
    "solar_panel" |
    "sort_19_ascending" |
    "sort_19_descending" |
    "sort_ascending" |
    "sort_ascending2" |
    "sort_az_ascending" |
    "sort_az_ascending2" |
    "sort_az_descending" |
    "sort_az_descending2" |
    "sort_descending" |
    "sort_descending2" |
    "sort_down" |
    "sort_down_minus" |
    "sort_down_plus" |
    "sort_up" |
    "sort_up_down" |
    "sort_up_down2" |
    "sort_up_down_question" |
    "sort_up_minus" |
    "sort_up_plus" |
    "spade" |
    "spam" |
    "speech_balloon" |
    "speech_balloon_answer" |
    "speech_balloon_question" |
    "spellcheck" |
    "spellcheck2" |
    "spider" |
    "spirit_level" |
    "sponge" |
    "spray_can" |
    "spreadsheed" |
    "spreadsheed_cell" |
    "spreadsheed_chart" |
    "spreadsheed_column" |
    "spreadsheed_data" |
    "spreadsheed_row" |
    "spreadsheed_sort_ascending" |
    "spreadsheed_sort_descending" |
    "spreadsheed_sum" |
    "spy" |
    "ssd_drive" |
    "stairs_down" |
    "stairs_up" |
    "standby" |
    "stapler" |
    "star" |
    "star2" |
    "star_and_crescent" |
    "star_of_david" |
    "steering_wheel" |
    "step" |
    "stethoscope" |
    "sticky_note" |
    "sticky_note_text" |
    "stock_ticker" |
    "stockbroker" |
    "stockbroker2" |
    "stopwatch" |
    "stopwatch2" |
    "store" |
    "stroller" |
    "submarine" |
    "suitcase" |
    "suitcase2" |
    "sum" |
    "sun" |
    "sun_dimmed" |
    "sun_half" |
    "sunglasses" |
    "surgeon" |
    "surveillance_camera" |
    "surveillance_camera2" |
    "switch2_off" |
    "switch2_on" |
    "switch3_off" |
    "switch3_on" |
    "switch_off" |
    "switch_on" |
    "sword" |
    "symbol_at" |
    "symbol_copyright" |
    "symbol_dollar" |
    "symbol_dollar_euro" |
    "symbol_euro" |
    "symbol_female" |
    "symbol_hash" |
    "symbol_male" |
    "symbol_paragraph" |
    "symbol_percent" |
    "symbol_pound" |
    "symbol_q" |
    "symbol_questionmark" |
    "symbol_yen" |
    "symbol_yuan" |
    "synagogue" |
    "system" |
    "tab_pane" |
    "table" |
    "table_selection_all" |
    "table_selection_block" |
    "table_selection_cell" |
    "table_selection_column" |
    "table_selection_range" |
    "table_selection_row" |
    "table_tennis_racket" |
    "tables" |
    "tablet_computer" |
    "tablet_computer_touch" |
    "tag" |
    "tags" |
    "tank" |
    "tank_truck" |
    "tape_measure" |
    "tape_measure2" |
    "target" |
    "taxi" |
    "tea_bag" |
    "teacher" |
    "teddy_bear" |
    "telephone" |
    "telephone2" |
    "telephone_box" |
    "telescope" |
    "temple" |
    "tennis_ball" |
    "tennis_racket" |
    "tent" |
    "terrorist" |
    "test_card" |
    "text" |
    "text_align_center" |
    "text_align_justified" |
    "text_align_left" |
    "text_align_right" |
    "text_binary" |
    "text_braille" |
    "text_field" |
    "text_speaker" |
    "text_tree" |
    "thermometer" |
    "thermometer2" |
    "thought" |
    "thread" |
    "ticket" |
    "timer" |
    "toaster" |
    "tobacco_pipe" |
    "toilet" |
    "toilet_paper" |
    "tool_tip" |
    "toolbox" |
    "tools" |
    "tooth" |
    "tooth_carious" |
    "torii" |
    "torpedo" |
    "touch" |
    "tower_crane" |
    "tractor" |
    "trafficlight_green" |
    "trafficlight_off" |
    "trafficlight_on" |
    "trafficlight_red" |
    "trafficlight_red_yellow" |
    "trafficlight_yellow" |
    "tram" |
    "tree" |
    "trojan_horse" |
    "trophy" |
    "truck" |
    "truck2" |
    "truck_container" |
    "truck_trailer" |
    "tv" |
    "tweezers" |
    "typewriter" |
    "ufo" |
    "umbrella_closed" |
    "umbrella_open" |
    "undo" |
    "uninstall" |
    "university" |
    "upload" |
    "user" |
    "user_earth" |
    "user_glasses" |
    "user_headphones" |
    "user_headset" |
    "user_message" |
    "user_mobilephone" |
    "user_monitor" |
    "user_smartphone" |
    "user_telephone" |
    "users" |
    "users2" |
    "users3" |
    "users4" |
    "users5" |
    "users_crowd" |
    "users_family" |
    "users_meeting" |
    "users_relation" |
    "users_relation2" |
    "utility_knife" |
    "vacuum_cleaner" |
    "van" |
    "vector_circle" |
    "vector_curve_cubic" |
    "vector_curve_quadratic" |
    "vector_ellipse" |
    "vector_line" |
    "vector_square" |
    "vector_triangle" |
    "vending_machine" |
    "video_camera" |
    "video_chat" |
    "video_chat2" |
    "videotape" |
    "view_1_1" |
    "violin" |
    "virus" |
    "voice_recorder" |
    "voodoo_doll" |
    "walkie_talkie" |
    "wall_barbed_wire" |
    "wallet" |
    "wallet_empty" |
    "warehouse" |
    "washing_powder" |
    "water" |
    "water_fish" |
    "water_tap" |
    "watering_can" |
    "watering_can_half" |
    "wax_seal" |
    "wax_seal_broken" |
    "web" |
    "webcam" |
    "wedding_rings" |
    "weight" |
    "weight2" |
    "wheat" |
    "wheel" |
    "wheel_loader" |
    "wheelbarrow" |
    "wheelbarrow_full" |
    "wheelchair" |
    "whistle" |
    "whistle_noise" |
    "wind_engine" |
    "wind_engine_offshore" |
    "wind_engines" |
    "windmill" |
    "window" |
    "window_cd" |
    "window_close" |
    "window_dialog" |
    "window_earth" |
    "window_environment" |
    "window_equalizer" |
    "window_explorer" |
    "window_font" |
    "window_gear" |
    "window_height" |
    "window_information" |
    "window_key" |
    "window_logon" |
    "window_network" |
    "window_oscillograph" |
    "window_sidebar" |
    "window_size" |
    "window_split_hor" |
    "window_split_ver" |
    "window_star" |
    "window_test_card" |
    "window_time" |
    "window_touch" |
    "window_warning" |
    "window_width" |
    "windows" |
    "windows_close" |
    "windsock" |
    "windup_key" |
    "wine" |
    "wine_bottle" |
    "wine_glass" |
    "wlan_antenna" |
    "wlan_router" |
    "woman" |
    "woman2" |
    "woman3" |
    "wooden_pallet" |
    "wooden_pallet_box" |
    "worker" |
    "worker2" |
    "workplace" |
    "workstation" |
    "workstation_network" |
    "worm" |
    "wrench" |
    "wristwatch" |
    "x-ray" |
    "yinyang" |
    "zoom_in" |
    "zoom_out";

export interface IconProps {
    name: GeoICONS;
    selected?: boolean | undefined;
    className?: string;
    onClick?: MouseEventHandler;
    title?: string;
}

export class Icon extends React.Component<IconProps, any> {

    constructor(props: IconProps) {
        super(props);
    }

    render(): JSX.Element | null {
        const {className, name, selected, title} = this.props;
        let iconFile = __CONFIG_APPBASE__ + "images/icons/";
        if (selected){
            iconFile += "selected/";
        } else {
            iconFile += "plain/";
        }
        iconFile += name + ".svg";
        const titleString = (typeof title === "string")? title: " ";
        return(
            <span className={"geo-icon icon--" + name + (className? " " + className: "")}
                onClick={this.props.onClick}><SVG src={iconFile} title={titleString}/></span>
        );
    }
}
